import React, { createContext, lazy, useContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserAccess } from "../../redux/Apps/users/userSlice";
import { DashboardSideMenu } from "../../static/staticdata";

const AccessContext = createContext();

export const AccessProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { user, token, userId, userAccess } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    if (token && userId && !userAccess) {
      dispatch(getUserAccess({ token, userId }));
    }
  }, [token, userId, userAccess, dispatch]);

  // const handleElementVisibility = (userAccess) => {
  //   if (!userAccess || !Array.isArray(userAccess)) return;

  //   // const hasHighAccess = userAccess.some(
  //   //   (role) => role.access_level === "high"
  //   // );

  //   // // If user has high access, show all elements
  //   // if (hasHighAccess) {
  //   //   const allElements = document.querySelectorAll('[id^="access_"]');
  //   //   allElements.forEach((element) => {
  //   //     element.style.display = "";
  //   //   });
  //   //   return;
  //   // }

  //   // Collect ALL allowed page IDs from all roles
  //   const allowedIds = [];
  //   userAccess.forEach((role) => {
  //     if (role.custom_access?.pages_id) {
  //       Object.values(role?.custom_access?.pages_id)?.forEach((moduleIds) => {
  //         if (Array.isArray(moduleIds)) {
  //           allowedIds?.push(...moduleIds?.filter((id) => id !== null));
  //         }
  //       });
  //     }
  //   });

  //   // Remove duplicates
  //   const uniqueAllowedIds = [...new Set(allowedIds)];
  //   console.log("Unique Allowed IDs:", uniqueAllowedIds);

  //   // const allAccessElements = document.querySelectorAll('[id^="access_"]');
  //   // console.log("All Access Elements:", allAccessElements);
  //   // console.log("Allowed IDs:", uniqueAllowedIds);

  //   // // Check each element
  //   // allAccessElements.forEach((element) => {
  //   //   if (uniqueAllowedIds?.includes(element.id)) {
  //   //     element.style.display = "";
  //   //   } else {
  //   //     // Hide elements that don't have permission
  //   //     element.style.display = "none";
  //   //     console.log(`Hiding element: ${element.id} (not in allowed list)`);
  //   //   }
  //   // });
  // };

  // useEffect(() => {
  //   handleElementVisibility(userAccess);
  // }, [userAccess]);

  useEffect(() => {
    if (!userAccess || !Array.isArray(userAccess)) return;

    // const hasHighAccess = userAccess.some(
    //   (role) => role.access_level === "high"
    // );

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // If high access, show all new elements
            // if (hasHighAccess) {
            //   if (node.id && node.id.startsWith("access_")) {
            //     node.style.display = "";
            //   }
            //   const childElements = node.querySelectorAll('[id^="access_"]');
            //   childElements.forEach((child) => {
            //     child.style.display = "";
            //   });
            //   return;
            // }

            // Collect allowed IDs from all roles
            const allowedIds = [];
            userAccess.forEach((role) => {
              if (role.custom_access?.pages_id) {
                Object.values(role.custom_access.pages_id).forEach(
                  (moduleIds) => {
                    if (Array.isArray(moduleIds)) {
                      allowedIds.push(...moduleIds.filter((id) => id !== null));
                    }
                  }
                );
              }
            });
            const uniqueAllowedIds = [...new Set(allowedIds)];

            // Handle the node itself if it has access_ id
            if (node.id && node.id.startsWith("access_")) {
              if (uniqueAllowedIds.includes(node.id)) {
                node.style.display = "";
              } else {
                node.style.display = "none";
                console.log(
                  `Hiding new element: ${node.id} (not in allowed list)`
                );
              }
            }

            // Handle child elements with access_ ids
            const childElements = node.querySelectorAll('[id^="access_"]');
            childElements.forEach((child) => {
              if (uniqueAllowedIds.includes(child.id)) {
                child.style.display = "";
              } else {
                child.style.display = "none";
                console.log(
                  `Hiding new child element: ${child.id} (not in allowed list)`
                );
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [userAccess]);

  const value = {
    userAccess,
    canNavigate: (path) => {
      if (!userAccess || !Array.isArray(userAccess)) return false;

      // if (userAccess.some((role) => role.access_level === "high")) return true;

      // Check if any role has this path
      return userAccess.some((role) =>
        role.custom_access?.modules_path?.includes(path)
      );
    },
    hasAccess: (permission) => {
      if (!userAccess || !Array.isArray(userAccess)) return false;

      // Check if any role has this permission
      return userAccess.some((role) =>
        role.custom_access?.modules_id?.includes(permission)
      );
    },
    isHighAccess: () => {
      if (!userAccess || !Array.isArray(userAccess)) return false;
      return userAccess.some((role) => role.access_level === "high");
    },
    hasModuleAccess: (moduleId) => {
      if (!userAccess || !Array.isArray(userAccess)) return false;

      // if (userAccess.some((role) => role.access_level === "high")) return true;

      return userAccess.some((role) =>
        role.custom_access?.modules_id?.includes(moduleId)
      );
    },
    hasPathAccess: (path) => {
      if (!userAccess || !Array.isArray(userAccess)) return false;

      // if (userAccess.some((role) => role.access_level === "high")) return true;

      return userAccess.some((role) =>
        role.custom_access?.modules_path?.includes(path)
      );
    },
    getAllowedPaths: () => {
      if (!userAccess || !Array.isArray(userAccess)) return [];

      // if (userAccess.some((role) => role.access_level === "high")) return ["*"];

      const allPaths = [];
      userAccess.forEach((role) => {
        if (role.custom_access?.modules_path) {
          allPaths.push(...role.custom_access.modules_path);
        }
      });
      return [...new Set(allPaths)]; // Remove duplicates
    },
    getAllowedModules: () => {
      if (!userAccess || !Array.isArray(userAccess)) return [];

      // if (userAccess.some((role) => role.access_level === "high")) return ["*"];

      const allModules = [];
      userAccess.forEach((role) => {
        if (role.custom_access?.modules_id) {
          allModules.push(
            ...role.custom_access.modules_id.filter((id) => id !== null)
          );
        }
      });
      return [...new Set(allModules)]; // Remove duplicates
    },
    getAllowedPageIds: () => {
      if (!userAccess || !Array.isArray(userAccess)) return [];

      if (userAccess.some((role) => role.access_level === "high")) return ["*"];

      const allowedIds = [];
      userAccess.forEach((role) => {
        if (role.custom_access?.pages_id) {
          Object.values(role.custom_access.pages_id).forEach((moduleIds) => {
            if (Array.isArray(moduleIds)) {
              allowedIds.push(...moduleIds.filter((id) => id !== null));
            }
          });
        }
      });
      return [...new Set(allowedIds)]; // Remove duplicates
    },
    hasPageAccess: (pageId) => {
      if (!userAccess || !Array.isArray(userAccess)) return false;

      if (userAccess.some((role) => role.access_level === "high")) return true;

      return userAccess.some((role) => {
        if (role.custom_access?.pages_id) {
          return Object.values(role.custom_access.pages_id).some(
            (moduleIds) =>
              Array.isArray(moduleIds) && moduleIds.includes(pageId)
          );
        }
        return false;
      });
    },

    hasAnyAccess: (items) => {
      if (!userAccess || !Array.isArray(userAccess)) return false;

      if (userAccess.some((role) => role.access_level === "high")) return true;

      // Get all allowed items from all roles
      const allAllowedPaths = [];
      const allAllowedModules = [];
      const allAllowedPageIds = [];

      userAccess.forEach((role) => {
        if (role.custom_access?.modules_path) {
          allAllowedPaths.push(...role.custom_access.modules_path);
        }
        if (role.custom_access?.modules_id) {
          allAllowedModules.push(
            ...role.custom_access.modules_id.filter((id) => id !== null)
          );
        }
        if (role.custom_access?.pages_id) {
          Object.values(role.custom_access.pages_id).forEach((moduleIds) => {
            if (Array.isArray(moduleIds)) {
              allAllowedPageIds.push(...moduleIds.filter((id) => id !== null));
            }
          });
        }
      });

      return items.some(
        (item) =>
          allAllowedPaths.includes(item) ||
          allAllowedModules.includes(item) ||
          allAllowedPageIds.includes(item)
      );
    },

    // New method to check if an element should be hidden
    shouldHideElement: (elementId) => {
      if (!userAccess || !Array.isArray(userAccess)) return true;

      // if (userAccess.some((role) => role.access_level === "high")) return false;

      const allowedIds = [];
      userAccess.forEach((role) => {
        if (role.custom_access?.pages_id) {
          Object.values(role.custom_access.pages_id).forEach((moduleIds) => {
            if (Array.isArray(moduleIds)) {
              allowedIds.push(...moduleIds.filter((id) => id !== null));
            }
          });
        }
      });

      const uniqueAllowedIds = [...new Set(allowedIds)];
      return !uniqueAllowedIds.includes(elementId);
    },
  };

  return (
    <AccessContext.Provider value={value}>{children}</AccessContext.Provider>
  );
};

export const useAccess = () => {
  const context = useContext(AccessContext);
  if (!context) {
    throw new Error("useAccess must be used within an AccessProvider");
  }
  return context;
};
